import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-6" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "Edit template", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Edit "),
  /*#__PURE__*/_createVNode("strong", null, "Day Template"),
  /*#__PURE__*/_createTextVNode(" to easily manage "),
  /*#__PURE__*/_createVNode("strong", null, "Work Periods"),
  /*#__PURE__*/_createTextVNode(" in your timeline! ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_day_template_form = _resolveComponent("day-template-form")
  const _component_loader = _resolveComponent("loader")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_loader, { "is-loading": _ctx.isDayTemplateLoading }, {
        default: _withCtx(() => [
          _createVNode(_component_day_template_form, {
            dayTemplate: _ctx.dayTemplate,
            onSubmit: _ctx.onDayTemplateEdit,
            "submit-text": "Save",
            isSubmitLoading: _ctx.isLoading,
            "with-template-name": ""
          }, null, 8, ["dayTemplate", "onSubmit", "isSubmitLoading"])
        ]),
        _: 1
      }, 8, ["is-loading"])
    ])
  ]))
}